import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { ConfigService, IsSigninService } from '@argalis-apps/angular-global';

@Injectable({
  providedIn: 'root'
})
export class IsAlreadyLoggedGuard  {
  constructor(private router: Router, private configService: ConfigService, private isSigninService: IsSigninService) {}

  async canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> {
    if (this.configService.getOptions().useTestData === true) {
      return true;
    } else {
      const askBackend = await new Promise(resolve => {
        this.isSigninService.checkSignIn().subscribe(
          (res: any) => {
            resolve(!res);
          },
          err => {
            resolve(true); // si erreur (serveur injoignable) on reste sur signin
          }
        );
      });
      if (askBackend === true) return true;
      return this.router.createUrlTree(['/']);
    }
  }

  async canActivateChild(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> {
    return this.canActivate(next, state);
  }
}
